import { Field } from '@headlessui/react';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { Label } from '@/components/form/label';
import { Button } from '@/components/ui/button';
import { SectionHeadingGroup } from '@/components/ui/section-heading-group';
import { useAddressBooks } from '@/hooks/use-address-books';
import { useCurrentUnit } from '@/hooks/use-current-unit';
import { api } from '@/redux/api';

interface formInput {
  addressBookId: string;
}

export const AddAddressBookForm: FC = () => {
  const [assignAddressBook] = api.useAssignAddressBookMutation();
  const { register, handleSubmit } = useForm<formInput>();
  const { data: unit } = useCurrentUnit();
  const { data: addressBooks, isFetching } = useAddressBooks();
  const onSubmit = (data: formInput) =>
    assignAddressBook({
      organisationId: unit?.organisation.id ?? -1,
      unitId: unit?.id ?? -1,
      actionType: 'assignAddressBook',
      addressBookId: data.addressBookId,
    });
  const options = [];
  for (const addressBook of addressBooks) {
    options.push(
      <option value={addressBook.addressBookId}>{addressBook.name}</option>,
    );
  }

  return (
    <div>
      {!isFetching && (
        <form
          className={'flex flex-col gap-1'}
          onSubmit={handleSubmit(onSubmit)}
        >
          <SectionHeadingGroup
            className="max-w-96"
            subtitle="Add an existing address book to this unit"
            title="Add an address book"
          />
          <Field className="flex flex-col">
            <Label>Address Book: </Label>
            <select className={''} {...register('addressBookId')}>
              {options}
            </select>
          </Field>
          <Button className="place-self-start" type="submit">
            Add Address Book
          </Button>
        </form>
      )}
    </div>
  );
};
